import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Table from '@common/Table'
import store from '../store'
import columns from './column'

@observer
export default class extends Component {
  render() {
    const { is_shop } = store
    return <Table store={store} columns={columns(is_shop)} />
  }
}
